import React, { Component } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getScheduledAuotoDialerCalls } from '../../actions/getCalls';
import { doCall } from '../../actions/call';
import CallMenu from '../call-menu.js';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import orderBy from 'lodash/orderBy';
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import timezones from '../../utils/timezones';
import Loader from '../Components/Loader';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

// this container is same for outgoing, incoming, autoDialer and queued calls
class ScheduledCalls extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            showErr: false,
            showCallsModal: props.showCallsModal,
            perPage: 100,
            activePage: 1,
            callsData: this.props.callsData,
            displayingCalls: [],
            displayingCallsAll: [],
            loading: false,
            totalData: 100,
            service_name: ''
        };
    }

    resetFilters = () => {
        const colFilters = {};
        this.props.columns.forEach(col => {
            if (col.filter) {
                colFilters[col.key] = '';
            }
        });
        return colFilters;
    }

    // updates state with column filters with empty value among other stuff and gets call data
    handleEnter = () => {
        this.setState({
            loading: true,
            startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            // selectedTimezone: moment.tz.guess()
            selectedTimezone: this.props.agentInfo.timezone,
        }, () => {
            this.getCallsData();
        });
    }
    // gets the data for calls with backend filters for pagination.
    getCallsData = () => {
        const colFilters = this.resetFilters();
        logData(colFilters);
        this.setState({
            loading: true,
            ...colFilters
        }, () => {
            let filter = {
                num_calls: this.state.perPage,
                offset: (this.state.activePage - 1) * this.state.perPage,
                begin_date: this.state.startDate,
                end_date: this.state.endDate,
                time_zone: this.state.selectedTimezone,
                today_only: 0
            };
            // dynamically calling action.
            this.props[this.props.callAction](filter).then((res) => {
                //this.props[this.props.callAction]();
                const mappedCalls = res.data.response[this.props.callDataParam].map(item => {
                    this.props.columns.forEach(col => {
                        if (col.operation === 'subtract') {
                            if (item[col.firstItem] !== null && item[col.secondItem] !== null) {
                                item[col.key] = item[col.firstItem] - item[col.secondItem];
                            } else {
                                item[col.key] = 0;
                            }
                        }
                    });
                    item['list_detail_id'] = item.phone_list[0].list_detail_id;

                    return item;
                });
                this.setState({
                    loading: false,
                    displayingCalls: mappedCalls,
                    displayingCallsAll: mappedCalls,
                    paginationItems: Math.round(this.state.totalData / this.state.perPage),
                    appliedTimezone: this.state.selectedTimezone
                });
            }, (err) => {
                logData(err);
                this.setState({
                    showErr: true,
                    loading: false,
                    errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
                });
            });
        });
    }

    /**
     * Gets value that needs to be displayed for table column.
     * compares for different column types.
     * @param  {object} item contact data
     * @param  {object} col  column data
     * @return {string}      value that needs to be displayed
     */
    getColumnValue = (item, col) => {
        let value = item[col.key];
        if (col.time) {
            value = moment.tz(item[col.key] * 1000, this.state.appliedTimezone).format('DD-MM-YYYY HH:mm');
        }
        return value;
    }

    // renders list of calls. loops through list data and columns
    renderCalls = () => {
        return this.state.displayingCalls.map((item) => {
            return (
                <tr key={item.call_id}>
                    {this.props.columns.map((col) => {
                        const extraAtrr = col.doCall ? {
                            onClick: this.makeCall,
                            id: item[col.key],
                            className: 'cursor'
                        } : {};
                        return (
                        (((col.key === "phone") && (item.phone_list.length > 0))? 
                        <td 
                           style={{ ...col.style }}
                           key={col.key}  
                        > {item.phone_list.map((phone) => {
                            return <div> {phone.phone} </div>
                        })} 
                        </td> : 
                        <td
                            style={{ ...col.style }}
                            key={col.key}
                            {...extraAtrr}
                        >
                            {this.getColumnValue(item, col)}
                    </td>) )
                    })}
                </tr>
            );
        });
    }

    // render header for table
    renderHeader = () => {
        return this.props.columns.map((item, key) => {
            return (
                <th
                    style={{ ...item.style, position: 'relative', cursor: item.key !== 'phone'? 'pointer' : 'default' }}
                    key={key}
                    id={item.key}
                    onClick={this.handleSort}
                    /* colspan={item.title !== 'phone_list'? "1" : "2" } */
                >
                    {item.title.length > 0 ? this.props.translations[item.title][this.props.selectedLanguage] : ''}
                    {(this.state[`${item.key}Sort`] && (item.key !== 'phone')) && <span
                        className={this.state[`${item.key}Sort`] == 'desc' ? 'headerSortUp' : 'headerSortDown'}
                        style={{ color: 'rgba(0, 0, 0, 0.5)', position: 'absolute', right: '20px' }}
                        aria-hidden="true"
                        id={item.key}
                        onClick={this.handleSort}
                    />}
                </th>
            );
        });
    }
    // shows filters for columns where it needs to be added
    renderFilters = () => {
        return this.props.columns.map((item, key) => {
            return (
                <td
                    style={{ ...item.style }}
                    key={key}
                    id={item.key}
                >
                    {item.filter &&
                        <input
                            type="text"
                            className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                            id={item.key}
                            onChange={this.handleCallsFilterChange}
                            value={this.state[item.key]}
                        />
                    }
                </td>
            );
        });
    }
    // handles sorting of table
    handleSort = (e) => {
        const sortType = this.state[`${e.target.id}Sort`] == 'desc' ? 'asc' : 'desc';
        const orderedData = orderBy(this.state.displayingCalls, e.target.id, sortType);
        const orderedDataAll = orderBy(this.state.displayingCallsAll, e.target.id, sortType);
        const colSorts = {};
        this.props.columns.forEach(col => {
            colSorts[`${[col.key]}Sort`] = null
        });
        this.setState({
            ...colSorts,
            [`${e.target.id}Sort`]: sortType,
            displayingCalls: orderedData,
            displayingCallsAll: orderedDataAll,
        });
    }
   
    // filters data
    handleCallsFilterChange = (e) => {
        const key = e.target.id;
        const filterValue = e.target.value;
        this.setState({
            [key]: filterValue
        }, () => {
            let filteredList = this.state.displayingCallsAll;
            this.props.columns.forEach(col => {
                if (col.filter) {
                    filteredList = filteredList.filter(item =>
                        item[col.key] ?
                            item[col.key].toLowerCase().includes(this.state[col.key].toLowerCase())
                            : null
                    );
                }
            });
            // const filteredList = this.state.displayingCallsAll.filter(item =>
            //     item[key].toLowerCase().includes(filterValue.toLowerCase()));
            this.setState({
                displayingCalls: filteredList
            });
        })
    }

    close = (key) => {
        this.setState({
            showErr: false
        }, () => {
            this.props.handleClose(key);
        });
    }
    // gets text according to type of modal opened
    getNoCallText = () => {
        const translations = {
            scheduled_autoDialer: 'noScheduledCalls'
        }
        let text = this.props.translations[translations[this.props.type]][this.props.selectedLanguage];
        return text;
    }

    handleAlertDismiss = () => {
        this.setState({
            showErr: false
        });
    }

    render() {
        return (
            <Modal
                dialogClassName="extraLarge"
                bsSize="lg"
                onEnter={this.handleEnter}
                show={this.props.showCallsModal}
                onHide={() => this.close('showCallsModal')}
                backdrop="static"
            >
                <Modal.Header className={`modal-content1${this.props.theme} modal-header${this.props.theme}`} closeButton>
                    <Modal.Title>{this.props.headerText}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={`modal-content1${this.props.theme}`} style={{ maxHeight: '100%' }}>
                    {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                        <p>{this.state.errorMsg}</p>
                    </Alert></div>}
                    
                    <div className="table-responsive">
                        <table className={`table-fixed table table${this.props.theme} table-hover${this.props.theme} m-a-0`}>
                            <thead>
                                <tr>
                                    {this.renderHeader()}
                                </tr>
                                <tr>
                                    {this.renderFilters()}
                                    <td />
                                </tr>
                            </thead>
                            <tbody style={{ maxHeight: 300, minHeight: this.state.displayingCalls.length > 0 ? 300 : '', paddingRight: 17 }}>
                                {this.state.loading && <h3><Loader width="20px" height="20px" /></h3>}
                                {!this.state.loading && this.renderCalls()}
                            </tbody>
                        </table>
                        {(!this.state.loading && this.state.displayingCalls.length == 0) &&
                            <h3 style={{ textAlign: 'center' }}>{this.getNoCallText()}</h3>}
                    </div>
                </Modal.Body>
                <Modal.Footer className={`modal-content1${this.props.theme}`}>
                    <nav className="text-center">
                        {/* <Pagination
          bsSize="sm"
          items={this.state.paginationItems}
          activePage={this.state.activePage}
          onSelect={this.handleSelect} /> */}
                    </nav>
                    <br />
                </Modal.Footer>
            </Modal>
        )
    }
}

function mapStateToProps(state) {
    return {
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        scheduledAutoDialerCalls: state.scheduledAutoDialerCalls,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}

const mapDispatchToProps = {
    getScheduledAuotoDialerCalls,
    doCall
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledCalls);



// WEBPACK FOOTER //
// ./src/agent/modals/ScheduledCalls.js